window.onload = function () {
    const script = document.createElement('script');
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute('data-use-service-core', '');
    script.defer = true;
    document.body.appendChild(script);
};

document.addEventListener('DOMContentLoaded', () => {
    if ($('.js-sp-testimonial-slider').length > 0) {
        $('.js-sp-testimonial-slider').slick({
            // infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: `<button type="button" class="slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/>
                </svg></button>`,
            nextArrow: `<button type="button" class="slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.3,
                        dots: true,
                        arrows: false,
                        infinite: false
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
    }
})